
import { Drawer } from "element-ui"
import drawerHeader from "../drawer/components/drawerHeader.vue"

export default {
  name: "UnableItem",
  API: ["open", "close"],
  components: {
    [Drawer.name]: Drawer,
    drawerHeader,
  },
  data() {
    return {
      visible: false,
      list: [],
      curDate: {},
      curTime: {},
    }
  },
  created() {},
  methods: {
    open(res) {
      this.visible = true
      this.list = res.list
      this.curDate = res.curDate
      this.curTime = res.curTime
    },
    close() {
      this.visible = false
    },
    handleDrawerOpened() {},
    handleDrawerClose() {
      this.list = []
      this.curDate = {}
      this.curTime = {}
    },
    handleContinue() {
      this.$emit("confirm", {
        curDate: this.curDate,
        curTime: this.curTime,
        list: this.list
      })
    }
  }
}
